import React, { useEffect } from "react";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import {
  FormControl,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  InputAdornment,
  Alert,
  Autocomplete,
  Box,
  Button,
  MenuItem,
  InputLabel,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Link from "@mui/material/Link";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import Span from "@jumbo/shared/Span";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import Div from "@jumbo/shared/Div";
import LoadingButton from "@mui/lab/LoadingButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import Stack from "@mui/material/Stack";
import Popover from "@mui/material/Popover";
import SaveIcon from "@mui/icons-material/Save";
import { useProfileContext } from "../context";
import { useAppMutation } from "../../../../services";
import teacherServices from "../../../../services/teacher-services";
import {
  PHONE_COUNTRIES,
  countryFormattingRules,
} from "../../../../utils/constants/appActions";
import parentServices from "../../../../services/parent-services";
import { useTranslation } from "react-i18next";
import TitleIcon from "@mui/icons-material/Title";
import Select from "@mui/material/Select";

const Contacts = ({ setStepsData, hide, stepsData, handleNext }) => {
  const { globalState, setGlobalState } = useProfileContext();
  const [errPhone, setErrPhone] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState("");
  const { t } = useTranslation();
  // Default phone objet -> drapeau FR visible et code +33 prerempli des l'ouverture.
  // User reste libre de changer via le dropdown.
  // @author Rabah Ziane - 2026-05-20
  const FR_PHONE_DEFAULT = {
    countryCode: "FR",
    label: "France",
    code: "33",
    number: "",
  };
  const [values, setValues] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    country: {
      countryCode: "FR",
      label: "France",
      code: "33",
      suggested: true,
    },
    phone: { ...FR_PHONE_DEFAULT },
    phone2: { ...FR_PHONE_DEFAULT },
    title: "",
  });
  const {
    mutate: updateInfo,
    isSuccess,
    data,
    isError,
    isLoading,
  } = useAppMutation(parentServices.updateProfileContactInfo);

  React.useEffect(() => {
    if (globalState.profile) {
      console.log("-----Profile------------------>", globalState.profile);
      // Si profile.phone/phone2 absent ou string vide -> fallback FR pour que
      // le drapeau + indicatif +33 soient visibles d'entree. Si phone existe
      // avec code mais sans countryCode (cas des anciens parents), on deduit
      // countryCode + label depuis PHONE_COUNTRIES pour que le drapeau s'affiche.
      // @author Rabah Ziane - 2026-05-20
      const p = globalState.profile;
      const ensurePhone = (val) => {
        if (!val || typeof val !== "object" || !val.code) {
          return { ...FR_PHONE_DEFAULT };
        }
        if (val.countryCode) return val;
        const match = PHONE_COUNTRIES.find(
          (c) => String(c.code) === String(val.code),
        );
        return {
          ...val,
          countryCode: match?.countryCode || FR_PHONE_DEFAULT.countryCode,
          label: match?.label || FR_PHONE_DEFAULT.label,
        };
      };
      setValues({
        ...p,
        phone: ensurePhone(p.phone),
        phone2: ensurePhone(p.phone2),
      });
    }
  }, [globalState]);

  useEffect(() => {
    if (stepsData) {
      const val = PHONE_COUNTRIES.find(
        (item) => item.code === stepsData.phone?.code,
      );
      stepsData.phone.label = val?.label;
      stepsData.phone.countryCode = val?.countryCode;
      setValues({ ...values, ...stepsData });
    }
  }, [stepsData]);
  React.useEffect(() => {
    if (isSuccess) {
      setGlobalState({ ...globalState, refreshList: true });
    }
  }, [isError, data, isSuccess]);

  const handleEmailIconClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [loading, setLoading] = React.useState(false);

  const handleClick111 = async () => {
    setErrMsg("");

    const { firstName, lastName, title, phone, phone2 } = values;
    const fullPhoneNumber = `+${phone.code}${phone.number}`;
    console.log("fullPhoneNumber", fullPhoneNumber);
    const fullNumberRegex =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;
    const fullPhoneNumberWithoutSpaces = fullPhoneNumber.replace(/\s/g, "");

    const fullPhoneNumber2 = `+${phone2.code}${phone2.number}`;
    console.log("fullPhoneNumber2", fullPhoneNumber2);
    const fullNumberRegex2 =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;
    const fullPhoneNumberWithoutSpaces2 = fullPhoneNumber2.replace(/\s/g, "");

    if (
      values.firstName &&
      values.lastName &&
      values.phone?.code &&
      values.phone?.number
    ) {
      if (!fullNumberRegex.test(fullPhoneNumberWithoutSpaces)) {
        setErrMsg(t("errMsg.invalidPhone"));
        setTimeout(() => {
          setErrMsg("");
        }, 3000);
        return;
      }
      const validatedFullPhoneNumber = fullPhoneNumberWithoutSpaces;
      const obj = {
        ...values,
        phone: {
          fullNumber: fullPhoneNumberWithoutSpaces,
          code: values.phone.code,
          number: values.phone.number,
        },
        phone2:
          phone2?.code && phone2?.number
            ? {
                fullNumber: fullPhoneNumberWithoutSpaces2,
                code: values.phone2.code,
                number: values.phone2.number,
              }
            : undefined,
      };
      console.log("Step2------------", obj);
      updateInfo(obj);
      setOpenDialog(false);
    } else {
      setErrMsg(t("errMsg.notFill"));
      setTimeout(() => {
        setErrMsg("");
      }, 3000);
    }
  };

  const handleClick1 = async () => {
    setErrMsg("");

    const { firstName, lastName, phone, phone2, title } = values;

    // Primary phone is required
    if (!firstName || !lastName || !phone?.code || !phone?.number || !title) {
      setErrMsg(t("errMsg.notFill"));
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }

    const fullPhoneNumber = `+${phone.code}${phone.number}`;
    const fullPhoneNumberWithoutSpaces = fullPhoneNumber.replace(/\s/g, "");
    const fullNumberRegex =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

    if (!fullNumberRegex.test(fullPhoneNumberWithoutSpaces)) {
      setErrMsg(t("errMsg.invalidPhone"));
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }

    // Prepare phone2 only if it exists
    let phone2Obj;
    if (phone2?.code && phone2?.number) {
      const fullPhoneNumber2 = `+${phone2.code}${phone2.number}`;
      const fullPhoneNumberWithoutSpaces2 = fullPhoneNumber2.replace(/\s/g, "");
      const fullNumberRegex2 =
        /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

      if (!fullNumberRegex2.test(fullPhoneNumberWithoutSpaces2)) {
        setErrMsg(t("errMsg.invalidPhone"));
        setTimeout(() => setErrMsg(""), 3000);
        return;
      }

      phone2Obj = {
        fullNumber: fullPhoneNumberWithoutSpaces2,
        code: phone2.code,
        number: phone2.number,
      };
    }

    // Build final object
    const obj = {
      ...values,
      phone: {
        fullNumber: fullPhoneNumberWithoutSpaces,
        code: phone.code,
        number: phone.number,
      },
      phone2: phone2Obj, // undefined if not provided
    };

    updateInfo(obj);
    setOpenDialog(false);
  };

  const handleCountryChange = (event, newValue) => {
    // FIX : sans countryCode + label, le drapeau (startAdornment) restait sur
    // l'ancien pays meme apres changement de code (ex: CZ +420 affichait drapeau FR).
    // @author Rabah Ziane - 2026-05-20
    setValues({
      ...values,
      phone: {
        ...values.phone,
        code: newValue.code,
        countryCode: newValue.countryCode,
        label: newValue.label,
      },
    });
  };

  return (
    <JumboCardQuick
      title={
        <Typography variant={"h4"} mb={0}>
          Informations
          <Span sx={{ color: "text.secondary", fontSize: 13 }}>
            <EditOutlinedIcon
              onClick={handleEmailIconClick}
              sx={{ fontSize: 13, ml: 1 }}
            />
          </Span>
        </Typography>
      }
      headerSx={{
        borderBottom: 1,
        borderColor: "divider",
      }}
      noWrapper
    >
      <List disablePadding sx={{ mb: 2 }}>
        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <EmailOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                {t("common.email")}
              </Typography>
            }
            secondary={
              <Link
                variant="body1"
                aria-describedby={id}
                onClick={handleClick}
                underline="none"
              >
                {values.email}
              </Link>
            }
          />
        </ListItem>
        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <InsertLinkOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                {t("parent-profile.title.name")}
              </Typography>
            }
            secondary={
              <Link variant="body1" href="#" underline="none">
                {values.title + " " + values.firstName + " " + values.lastName}
              </Link>
            }
          />
        </ListItem>
        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <LocalPhoneOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                {t("parent-profile.title.phone")}
              </Typography>
            }
            secondary={
              <Typography variant="body1" color="text.primary">
                {values.phone?.fullNumber}
              </Typography>
            }
          />
        </ListItem>

        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <LocalPhoneOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                {t("parent-profile.title.phone2")}
              </Typography>
            }
            secondary={
              <Typography variant="body1" color="text.primary">
                {values.phone2?.fullNumber}
              </Typography>
            }
          />
        </ListItem>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          sx={{
            // Set width and height using sx prop
            "& .MuiPopover-paper": {
              width: "auto",
            },
          }}
        >
          <Div
            sx={{
              "& .MuiTextField-root": {
                m: 2,
              },
            }}
          >
            <TextField
              id="input-with-icon-textfield"
              sx={{ width: "300px" }}
              size="small"
              name="email"
              label={t("common.email")}
              value={values.email}
              onChange={handleChange("email")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
                readOnly: true,
              }}
              variant="outlined"
            />
          </Div>
        </Popover>
      </List>

      <Div>
        <Dialog open={openDialog}>
          <DialogTitle>{t("parent-profile.title.updateContact")}</DialogTitle>
          <DialogContent>
            <FormControl noValidate autoComplete="off">
              <Div
                sx={{
                  "& .MuiTextField-root": {
                    mb: 3,
                    mt: 0.9,
                  },
                }}
              >
                <TextField
                  id="input-with-icon-textfield"
                  fullWidth
                  size="small"
                  name="email"
                  label={t("common.email")}
                  value={values.email}
                  onChange={handleChange("email")}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                  variant="outlined"
                />

                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel id="title-select-label">
                    {t("common.title")}
                  </InputLabel>
                  <Select
                    labelId="title-select-label"
                    id="title-select"
                    value={values.title}
                    onChange={handleChange("title")}
                    label={t("common.title")}
                    startAdornment={
                      <InputAdornment position="start">
                        <TitleIcon />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="Mr">{t("common.mr")}</MenuItem>
                    <MenuItem value="Mrs">{t("common.mrs")}</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  id="input-with-icon-textfield"
                  fullWidth
                  size="small"
                  name="firstName"
                  label={t("common.firstName")}
                  value={values.firstName}
                  onChange={handleChange("firstName")}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                />

                <TextField
                  id="input-with-icon-textfield"
                  fullWidth
                  size="small"
                  name="lastName"
                  label={t("common.lastName")}
                  value={values.lastName}
                  onChange={handleChange("lastName")}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                />

                <Div
                  sx={{ mt: 1, mb: 2, display: "flex", alignItems: "center" }}
                >
                  <FormControl
                    variant="outlined"
                    sx={{ flex: "0 0 130px", marginRight: 2 }}
                  >
                    {values.phone?.code && (
                      <Autocomplete
                        defaultValue={values.phone}
                        options={PHONE_COUNTRIES}
                        autoHighlight
                        onChange={handleCountryChange}
                        getOptionLabel={(option) => {
                          return " +" + option.code;
                        }}
                        disableClearable={true}
                        // Popper plus large que l'input 130px pour eviter le wrap
                        // des items "Andorra (AD) +376" sur 3 lignes.
                        // @author Rabah Ziane - 2026-05-20
                        slotProps={{ paper: { sx: { minWidth: 280 } } }}
                        // Recherche par nom du pays, code ISO ou indicatif.
                        // Sinon le getOptionLabel ne renvoie que "+33" et taper
                        // "France" ne matche rien dans la liste.
                        // @author Rabah Ziane - 2026-05-20
                        filterOptions={(options, { inputValue }) => {
                          const q = inputValue.toLowerCase().trim();
                          if (!q) return options;
                          return options.filter(
                            (o) =>
                              (o.label || "").toLowerCase().includes(q) ||
                              (o.countryCode || "").toLowerCase().includes(q) ||
                              String(o.code || "").includes(q),
                          );
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{
                              "& > img": { mr: 2, flexShrink: 0 },
                              whiteSpace: "nowrap",
                            }}
                            {...props}
                          >
                            <img
                              loading="lazy"
                              width="20"
                              src={`https://flagcdn.com/w20/${option.countryCode?.toLowerCase()}.png`}
                              srcSet={`https://flagcdn.com/w40/${option.countryCode?.toLowerCase()}.png 2x`}
                              alt=""
                            />
                            {option.label} ({option.countryCode}) +{option.code}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={"Code"}
                            error={errPhone}
                            required
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password",
                            }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <React.Fragment>
                                  {values.phone && values.phone.countryCode && (
                                    <img
                                      loading="lazy"
                                      width="20"
                                      src={`https://flagcdn.com/w20/${values.phone.countryCode?.toLowerCase()}.png`}
                                      srcSet={`https://flagcdn.com/w40/${values.phone.countryCode?.toLowerCase()}.png 2x`}
                                      alt=""
                                    />
                                  )}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  </FormControl>

                  <FormControl variant="outlined" sx={{ flex: 1 }}>
                    <TextField
                      required
                      id="phone"
                      label={t("common.phone")}
                      error={errPhone}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={values.phone?.number}
                      onChange={(event) => {
                        let inputNumber = event.target.value;

                        // Remove leading zeros
                        const sanitizedNumber = inputNumber
                          .replace(/\D/g, "")
                          .replace(/^0+/, "");

                        let phone = values.phone;
                        phone.number = sanitizedNumber;

                        // Get selected country code
                        const selectedCountryCode = phone.code;

                        // Find the formatting rule for the selected country code
                        const countryFormattingRule =
                          countryFormattingRules.find(
                            (rule) => rule.code === selectedCountryCode,
                          );

                        // Enforce maximum digits restriction based on country code
                        if (countryFormattingRule) {
                          const maxDigits = countryFormattingRule.maxDigits;

                          // If the input length exceeds the maximum allowed digits, truncate the input
                          if (phone.number.length > maxDigits) {
                            phone.number = phone.number.slice(0, maxDigits);
                          }

                          // If the input length equals the maximum allowed digits, prevent further input
                          if (phone.number.length === maxDigits) {
                            event.preventDefault();
                          }
                        }

                        setValues({ ...values, phone });
                      }}
                    />
                  </FormControl>
                </Div>

                {/* Phone 2 */}
                <Div
                  sx={{ mt: 1, mb: 2, display: "flex", alignItems: "center" }}
                >
                  <FormControl
                    variant="outlined"
                    sx={{ flex: "0 0 130px", marginRight: 2 }}
                  >
                    <Autocomplete
                      defaultValue={values.phone2}
                      options={PHONE_COUNTRIES}
                      autoHighlight
                      onChange={(event, newValue) => {
                        // FIX meme bug que handleCountryChange : sync drapeau + label.
                        // @author Rabah Ziane - 2026-05-20
                        setValues({
                          ...values,
                          phone2: {
                            ...values.phone2,
                            code: newValue.code,
                            countryCode: newValue.countryCode,
                            label: newValue.label,
                          },
                        });
                      }}
                      getOptionLabel={(option) => " +" + option.code}
                      disableClearable={true}
                      // Meme fix que le 1er Autocomplete phone : popper 280px.
                      // @author Rabah Ziane - 2026-05-20
                      slotProps={{ paper: { sx: { minWidth: 280 } } }}
                      // Meme filterOptions que le 1er Autocomplete.
                      // @author Rabah Ziane - 2026-05-20
                      filterOptions={(options, { inputValue }) => {
                        const q = inputValue.toLowerCase().trim();
                        if (!q) return options;
                        return options.filter(
                          (o) =>
                            (o.label || "").toLowerCase().includes(q) ||
                            (o.countryCode || "").toLowerCase().includes(q) ||
                            String(o.code || "").includes(q),
                        );
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{
                            "& > img": { mr: 2, flexShrink: 0 },
                            whiteSpace: "nowrap",
                          }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            src={`https://flagcdn.com/w20/${option.countryCode?.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${option.countryCode?.toLowerCase()}.png 2x`}
                            alt=""
                          />
                          {option.label} ({option.countryCode}) +{option.code}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Code"}
                          error={errPhone}
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                {values.phone2?.countryCode && (
                                  <img
                                    loading="lazy"
                                    width="20"
                                    src={`https://flagcdn.com/w20/${values.phone2.countryCode?.toLowerCase()}.png`}
                                    srcSet={`https://flagcdn.com/w40/${values.phone2.countryCode?.toLowerCase()}.png 2x`}
                                    alt=""
                                  />
                                )}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl variant="outlined" sx={{ flex: 1 }}>
                    <TextField
                      id="phone2"
                      label={t("common.phone2")}
                      error={errPhone}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={values.phone2?.number}
                      onChange={(event) => {
                        let inputNumber = event.target.value;
                        const sanitizedNumber = inputNumber
                          .replace(/\D/g, "")
                          .replace(/^0+/, "");
                        let phone2 = values.phone2 || {};
                        phone2.number = sanitizedNumber;

                        // Same formatting restriction logic as phone
                        const selectedCountryCode = phone2.code;
                        const countryFormattingRule =
                          countryFormattingRules.find(
                            (rule) => rule.code === selectedCountryCode,
                          );
                        if (countryFormattingRule) {
                          const maxDigits = countryFormattingRule.maxDigits;
                          if (phone2.number.length > maxDigits) {
                            phone2.number = phone2.number.slice(0, maxDigits);
                          }
                        }

                        setValues({ ...values, phone2 });
                      }}
                    />
                  </FormControl>
                </Div>

                <Stack
                  sx={{
                    mb: 2,
                    width: "90%",
                    mx: "auto",
                    display: "block",
                    position: "relative", // Add position relative to enable absolute positioning of loader
                  }}
                  spacing={2}
                >
                  {errMsg && <Alert severity="error">{errMsg}</Alert>}
                </Stack>

                <Div sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Button
                    sx={{ mr: 1, width: "30%" }}
                    onClick={() => setOpenDialog(false)}
                  >
                    {t("common.closeBtn")}
                  </Button>
                  <Div sx={{ flex: "1 1 auto" }} />

                  <LoadingButton
                    type="submit"
                    variant="contained"
                    size="large"
                    loading={loading}
                    onClick={handleClick1}
                    sx={{ width: "30%" }}
                  >
                    {t("common.saveBtn")}
                  </LoadingButton>
                </Div>
              </Div>
            </FormControl>
          </DialogContent>
        </Dialog>
      </Div>
    </JumboCardQuick>
  );
};

export default Contacts;
